const validateEmail = (emailId) => {
  const regEmail =
    //eslint-disable-next-line

    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  return regEmail.test(emailId);
};
export default validateEmail;

export const validateMobileNumber = (mobile) => {
  const regMobile = /^[0-9]{10}$/;
  return regMobile.test(mobile);
};

export const nonEmpty = (value) => {
  if (value.length < 1) {
    return false;
  } else {
    return true;
  }
};
export const emptySpaceValidation = (space) => {
  // const regSpace = /^\s*$/;
  return /\s/g.test(space);
};

export const createCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  } else {
    expires = '';
  }

  document.cookie = name + '=' + value + expires + '; path=/';
};